import OpenIDConnect_vue_vue_type_script_setup_true_lang_default from "./OpenIDConnect.vue.script.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/OpenIDConnect.vue
var OpenIDConnect_default = OpenIDConnect_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { OpenIDConnect_default as default };

//# sourceMappingURL=OpenIDConnect.vue.js.map